import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../services/common/api.service';
import { Jsonp } from '@angular/http';
import { environment } from 'environments/environment';
@Injectable()

export class UserService {
  data: any = {};
  datanew: any = {};

  constructor(private router: Router, private api: ApiService) {

  }
  APIURL = "api/ExcuteOracle";
  //dang nhap
  login(taiKhoan, matKhau) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_DANGNHAP"}',
      "para": '{"v_TAIKHOAN":"' + taiKhoan + '","v_MATKHAU":"' + matKhau + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  checkLoggedIn() {
    //sonnt: neu kiem tra chua co thong tin trong local storage --> tra ve false 
    if (localStorage.getItem("UserInfo") == null || localStorage.getItem("UserInfo") == undefined) {
      return false;
    }
    else {
      //sonnt:neu co tra ve true
      return true;
    }
  }

  //sua thong tin nguoi dung
  editCurrentUser(taiKhoan, tenNguoiDung, email, soDienThoai, diaChi) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_SUA_TT_NGUOI_DUNG_HIENTAI"}',
      "para": '{"v_TAIKHOAN":"' + taiKhoan + '","v_TENNGUOIDUNG":"' + tenNguoiDung + '","v_EMAIL":"' + email + '","v_SODIENTHOAI":"' + soDienThoai + '","v_DIACHI":"' + diaChi + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //sua thong tin nguoi dung
  editUser(taiKhoan, tenNguoiDung, email, soDienThoai, diaChi, danhMucID, loaiTaiKhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_SUA_TT_NGUOI_DUNG"}',
      "para": '{"v_TAIKHOAN":"' + taiKhoan + '","v_TENNGUOIDUNG":"' + tenNguoiDung + '","v_EMAIL":"' + email + '","v_SODIENTHOAI":"' + soDienThoai + '","v_DIACHI":"' + diaChi + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '","v_DANHMUCID":"' + danhMucID + '","v_LOAITAIKHOAN":"' + loaiTaiKhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  //lay danh sach nhung nguoi dung dang quan ly
  getAllUserByMaTaiKhoan(mataikhoan, pageNum, numRecs) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAYDS_TAIKHOAN"}',
      "para": '{"v_MATAIKHOAN ":"' + mataikhoan + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //them moi nguoi dungs
  createUser(taiKhoan, matKhau, idDanhMuc, loaiTaiKhoan, tenNguoiDung, email, soDienThoai, diaChi, hienThi) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_THEM_TAIKHOAN"}',
      "para": '{"v_TAIKHOAN":"' + taiKhoan + '","v_MATKHAU":"' + matKhau + '","v_DANHMUCID":"' + idDanhMuc + '","v_LOAITAIKHOAN":"' + loaiTaiKhoan + '","v_TENNGUOIDUNG":"' + tenNguoiDung + '","v_EMAIL":"' + email + '","v_SODIENTHOAI":"' + soDienThoai + '","v_DIACHI":"' + diaChi + '","v_HIENTHI":"' + hienThi + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //lay thong tin user theo ma tai khoan
  getUserByMaTaiKhoan(mataikhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAY_TT_TAIKHOAN"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //xoa tai khoan
  deleteUserByMaTaiKhoan(mataikhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_XOA_TAIKHOAN"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //mo khoa tai khoan
  moKhoaUserByMaTaiKhoan(mataikhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_MOKHOA_TAIKHOAN "}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //lay tai khoan dang dang nhap
  getCurrentUser() {
    let currentUser = JSON.parse(localStorage.getItem("UserInfo"));
    return currentUser;
  }
  //lay ma tai khoan cua nguoi dang dang nhap
  getMaTaiKhoanCurrentUser() {
    let currentUser = this.getCurrentUser();
    return currentUser.mataikhoan;
  }
  //lay lich su hoat dong 
  getLichSuHoatDong(taikhoan, tungay, denngay, loaisukien, pageNum, numRecs) {
    let curentUser = JSON.parse(localStorage.getItem("UserInfo"));
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAY_LICHSU_HOATDONG"}',
      "para": '{"v_TAIKHOAN":"' + taikhoan + '","v_TUNGAY":"' + tungay + '","v_TOINGAY":"' + denngay + '","v_LOAISUKIEN":"' + loaisukien + '","v_pagenum":"' + pageNum + '","v_numrecs":"' + numRecs + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //dang xuat
  logOut() {
    sessionStorage.clear();
    //sessionStorage.removeItem(environment.sessionDanhMucName);
    localStorage.removeItem(environment.LOCAL_USER_NAME);
    this.router.navigate(['/pages/login']);
  }
  //doi mat khau
  doiMatKhau(mataikhoan, matkhaumoi, matkhaucu) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_THAY_MATKHAU"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATKHAUMOI":"' + matkhaumoi + '","v_MATKHAUCU":"' + matkhaucu + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //reset mat khaus
  resetMatKhau(mataikhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_THAY_MATKHAU_MACDINH"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //kiem tra tai khoan co trung trong db hay khong
  kiemTraTaiKhoan(taikhoan) {
    let curentUser = this.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_KIEMTRA_TONTAI_TAIKHOAN"}',
      "para": '{"v_TAIKHOAN":"' + taikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + curentUser.mataikhoan + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //Kiểm tra tài khoản có được sử dụng chức năng được chọn hay không
  kiemTraQuyen(machucnang) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_PHANQUYEN.P_KIEMTRA_QUYEN"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_machucnang":"' + machucnang + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //Kiểm tra tài khoản được làm gì tại chức năng được chọn
  kiemTraQuyen_THEM_SUA_XOA(machucnang) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_PHANQUYEN.P_KIEMTRA_QUYEN_THEM_SUA_XOA"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_machucnang":"' + machucnang + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //Kiểm tra tài khoản được làm gì tại chức năng được chọn
  thongkeDANGNHAP(taikhoan, danhmuc, tungay, denngay, sodong, sotrang) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_THONGKEDANGNHAP"}',
      "para": '{"v_MATAIKHOAN_THUCHIEN":"' + mataikhoan
        + '","v_MATAIKHOAN":"' + taikhoan
        + '","v_DANHMUC":"' + danhmuc
        + '","v_TUNGAY":"' + tungay
        + '","v_DENNGAY":"' + denngay
        + '","v_numrecs":"' + sodong
        + '","v_pagenum":"' + sotrang
        + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //Kiểm tra  thống kê đăng nhập
  thongkedangnhapthanhvien(danhmuc) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.ThongKeThanhVienDangNhap"}',
      "para": '{"v_Code":"' + danhmuc + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //Lấy danh sách tài khoản theo điện lực.
  dsTaiKhoanTheoDienLuc(taikhoan, danhmuccha, sodong, sotrang) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAY_DSTK_THEOTHUMUC"}',
      "para": '{"v_MATAIKHOAN_THUCHIEN":"' + mataikhoan
        + '","v_MATAIKHOAN":"' + taikhoan
        + '","v_DANHMUCCHA":"' + danhmuccha
        + '","v_numrecs":"' + sodong
        + '","v_pagenum":"' + sotrang
        + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  exportExcelQuanLyNguoiDung(taikhoan, danhmuccha, sotrang, sodong, tendonvi, tenchucnang, thoidiemtruyvan,) {
    let cols = [];
    cols = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "taikhoan", "label": "Tài khoản", "horizontalalignment": "left" },
      { "name": "tennguoidung", "label": "Tên", "horizontalalignment": "left" },
      { "name": "email", "label": "Email", "horizontalalignment": "left" },
      { "name": "sodienthoai", "label": "Số điện thoại", "horizontalalignment": "left" },
      { "name": "landangnhapcuoi", "label": "Lần đăng nhập cuối", "horizontalalignment": "center" },
      { "name": "ngaytao", "label": "Ngày tạo", "horizontalalignment": "center" },
      { "name": "loaitaikhoan", "label": "Loại tài khoản", "horizontalalignment": "left" }
    ];
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      config: JSON.stringify({ namesql: "PKG_TAIKHOAN.P_LAY_DSTK_THEOTHUMUC" }),
      para: JSON.stringify({
        v_MATAIKHOAN_THUCHIEN: mataikhoan,
        v_MATAIKHOAN: taikhoan,
        v_DANHMUCCHA: danhmuccha,
        v_numrecs: sodong,
        v_pagenum: sotrang
      }),
      title: tenchucnang,//+ " " + thoidiemtruyvan,
      header: "Thời điểm truy vấn: " + thoidiemtruyvan,
      filename: tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan,
      sheets: tenchucnang,
      columns: cols,
      data: ""
    };
    var filename = tendonvi + "_" + tenchucnang + "_" + thoidiemtruyvan;

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }


  //Kiểm tra danh tài khoản và email có đồng nhất không?
  checkEmail(taikhoan, email) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_KTRA_TK_EMAIL"}',
      "para": '{"v_TAIKHOAN":"' + taikhoan
        + '","v_EMAIL":"' + email
        + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //reset về mật khẩu mặc định
  resetMk(mataikhoan, mataikhoan1) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_THAY_MATKHAU_MACDINH"}',
      "para": '{"v_MATAIKHOAN":"' + mataikhoan + '","v_MATAIKHOAN_THUCHIEN":"' + mataikhoan1 + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  //gửi Email
  sendEmail(mailnhan, noidung) {
    return this.api.Excute("api/SendEmail?mailnhan=" + mailnhan + "&content=" + noidung, "")
  }
  //Cập nhật lại email nếu là lần đầu đăng nhập vào hệ thống
  updateEmail(username) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_UPDATE_EMAIL"}',
      "para": '{"v_USERNAME":"' + username + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  };

  //Lấy danh sách tài khoản theo điện lực.
  dsDiemDoPhanQuyen(taikhoan) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_LAY_DS_DIEMDO_PHANQUYEN"}',
      "para": '{"v_MATAIKHOAN":"' + taikhoan + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  phanquyen(mataikhoan) {
    var param = {
      "config": '{"namesql":"PKG_TAIKHOAN.P_PHANQUYEN"}',
      "para": '{"V_MATAIKHOAN":"' + mataikhoan + '",}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  insertListQuyen(tableDanhMuc, tableDiemDo) {
    var param = {
      "tableDanhMuc": tableDanhMuc,
      "tableDiemDo": tableDiemDo,
    };
    return this.api.Excute("api/phanquyen/phanquyendiemdo", param);
  }

  saveLog(sukien, loaisukien, thongtincu, thongtinmoi, ip, danhmucid) {
    let mataikhoan = this.getCurrentUser().mataikhoan;
    var param = {
      "config": '{"namesql":"PKG_LOG.P_THEM_LOG"}',
      "para": '{"TAIKHOAN":"' + mataikhoan + '","THOIDIEM":"","SUKIEN":"' + sukien + '","LOAISUKIEN":"' + loaisukien + '","THONGTINMOI":"' + thongtincu + '","THONGTINCU":"' + thongtinmoi + '","IP":"' + ip + '","DANHMUCID":"' + danhmucid + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }

  check_socongto_kh_congto2chieu(socongtokh) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_CHECK_SCTO2CHIEU"}',
      "para": '{"v_SOCONGTO":"' + socongtokh + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }
  // cập nhật khách hàng là công  tơ 2 chiều
  update_khachhangcongto2chieu(socongtokh) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_SUA_TT_KHACHHANG_CTO2CHIEU"}',
      "para": '{"v_SOCONGTO":"' + socongtokh + '"}'
    };
    return this.api.Excute(this.APIURL, param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/user.service.ts